var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94597 1.0529C7.55544 0.662379 6.92228 0.662379 6.53175 1.0529C6.14123 1.44343 6.14123 2.07659 6.53175 2.46712L11.0635 6.99887L1 6.99887C0.447715 6.99887 -4.2146e-08 7.44658 0 7.99887C-4.2146e-08 8.55115 0.447715 8.99887 1 8.99887H11.0635L6.53175 13.5306C6.14123 13.9211 6.14123 14.5543 6.53175 14.9448C6.92228 15.3354 7.55544 15.3354 7.94597 14.9448L13.4777 9.41308C14.2588 8.63203 14.2588 7.3657 13.4777 6.58466L7.94597 1.0529Z",
    fill: "#ED0334"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.a8de5f2d34cc5ba9154eb2caddecde04.svg";
export { ForwardRef as ReactComponent };